const key = 'SDK_USER_LOGIN_DATA_KEY'

const auth = {
  // login
  getToken() {
    const data = JSON.parse(localStorage.getItem(key))
    return data || {}
  },
  setToken(value) {
    return localStorage.setItem(key, JSON.stringify(value))
  },
  removeToken() {
    return localStorage.removeItem(key)
  }
}

export default auth